import {Fragment } from "react"
import {SkipDays} from "../../calendarBuilder"


export const July = () => {
    return (
        <Fragment>{SkipDays(3, 5, [13, 14, 15, 16, 17, 18, 19, 20])}</Fragment>  
    )
}